module.exports = __webpack_public_path__ + "img/4.7a014a26.png";